import { cva, VariantProps } from 'class-variance-authority';
import { Loader2Icon } from 'lucide-react';
const variants = cva('flex justify-center items-center', {
  variants: {
    size: {
      fullScreen: 'absolute top-0 left-0 w-full h-screen',
      default: '',
    },
  },
});

export interface LoadingProps extends VariantProps<typeof variants> {
  className?: string;
}

export const Loading = ({ className, size }: LoadingProps) => {
  return (
    <div className={variants({ size, className })}>
      <Loader2Icon className="animate-spin" />
    </div>
  );
};
